<dynamic-view-v2
    *ngIf="!isLoading"
    entityType="schedule-types"
    [viewName]="title"
    [record]="scheduleTypeRecord"
    [fields]="fields"
    [showLocalizedValuesButton]="true"
>
</dynamic-view-v2>
